
export default () => ({
    loading: true,
    posts: [],
    currentPost: null
})
